import { fromJS } from 'immutable'
import {
  SALE_PRODUCT_GET_REQUEST,
  SALE_PRODUCT_GET_SUCCESS,
  SALE_PRODUCT_GET_FAILURE,
  SALE_PRODUCT_GET_RESET,
} from '../../actions/sale-product/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SALE_PRODUCT_GET_REQUEST:
      return state
        .set('isFetching', true)
    case SALE_PRODUCT_GET_SUCCESS:
      return state
        .set('product', fromJS(action.payload.product))
        .set('isFetching', false)
    case SALE_PRODUCT_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case SALE_PRODUCT_GET_RESET:
      return state
        .set('isFetching', false)
        .set('product', null)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sale-product/sale-product-get-reducer.js